import React, { useEffect } from 'react';
import { DetailPanel, DetailPanelData, DetailPanelGroup } from "../Common/DetailPanel";
import CommonAssetDetails from './CommonAssetDetails';
import ApplianceAssetDetails from './ApplianceAssetDetails';
import BlowbackPreventer from './BlowbackPreventer';
import LeakMonitoringDevice from './LeakMonitoringDevice';
import Cylinders from './CylinderHeaders';
import CoolingAppliance from './CoolingAppliance';
import SystemAdminInventoryHeaders from './SystemAdminInventoryHeaders';
import UserInfo from '../../UserInfo';
import MainDetails from './Details/CoolingSystems/MainDetails';
import GeneralInformation from './Details/CoolingSystems/GeneralInformation';
import RefrigerantInformation from './Details/CoolingSystems/RefrigerantInformation';
import AssetStatusDetails from './Details/CoolingSystems/AssetStatusDetails';
import ManufacturerInformation from './Details/CoolingSystems/ManufacturerInformation';
import AdditionalInformation from './Details/CoolingSystems/AdditioanlInformation';
import Enums from '../../enums';

const {
    ComfortCooling,
    Refrigeration,
    ProcessCooling
} = Enums.AssetTypes;

const InventoryHeader = ({
    data,
    setHeaderCollapsed,
    aliases,
    regulatedAssetTypes = [],
    assetType,
    pwaActionItemsCount = 0
}) => {
    const isSystemAdmin = (UserInfo.isSuperTenantAdmin() || UserInfo.isSystemAdministrator());
    const isCoolingSystems = [ComfortCooling, Refrigeration, ProcessCooling].includes(assetType);

    return (
        <>
            <div className="p-0 mt-0 col-md-12 flex f-jb">
                <DetailPanel
                    expandable
                    setHeaderCollapsed={setHeaderCollapsed}
                    pwaActionItemsCount={pwaActionItemsCount}
                >
                    {
                        isCoolingSystems ? (
                            <>
                                <MainDetails data={data} regulatedAssetTypes={regulatedAssetTypes} />
                                <DetailPanelGroup title={"General Information"}>
                                    <GeneralInformation data={data} aliases={aliases} />
                                </DetailPanelGroup>
                                <DetailPanelGroup title={"Refrigerant Information"}>
                                    <RefrigerantInformation data={data} />
                                </DetailPanelGroup>
                                <DetailPanelGroup title={"Asset Status"}>
                                    <AssetStatusDetails data={data} />
                                </DetailPanelGroup>
                                <DetailPanelGroup title={"Manufacturer Information"}>
                                    <ManufacturerInformation data={data} />
                                </DetailPanelGroup>
                                <DetailPanelGroup title={"Additional Information"}>
                                    <AdditionalInformation data={data} />
                                </DetailPanelGroup>
                            </>
                        ) : (
                            <>
                                <CommonAssetDetails data={data} regulatedAssetTypes={regulatedAssetTypes} />
                                <ApplianceAssetDetails data={data} />
                                <BlowbackPreventer data={data} />
                                <LeakMonitoringDevice data={data} />
                                <CoolingAppliance data={data} />
                                <Cylinders data={data} isSystemAdministrator={isSystemAdmin} />
                                {isSystemAdmin && (
                                    <SystemAdminInventoryHeaders data={data} />
                                )}
                                <DetailPanelData id='AssetAlias' title="ALIAS / EXTERNAL ID" data={aliases} isClickable={UserInfo.isNativeAdminRole()} />
                                {/*<DetailPanelData id='RegulatedAssets' title="U.S.-based Regulations" data={selectedRegulatedAssetTypes} />*/}
                            </>
                        )
                    }
                </DetailPanel>
            </div>
        </>
    );
};

export default InventoryHeader;
